import React, { useEffect, useState } from "react";
import { Container } from "./styles";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { addDays, addSeconds, format, intervalToDuration } from "date-fns";
import Status from "../../../components/status";
import { Button, Pagination, Spin, DatePicker, Select, Modal, Tooltip } from "antd";
import locale from "antd/es/date-picker/locale/pt_BR";
import dayjs from "dayjs";
import {
  getValue,
  getDate,
  formatarDuracaoCompleta,
} from "../../../services/functions";
import CountUp from "react-countup";
import { Card, Message, ViewInput } from "../../../GlobalStyles";

function getDeadlineInfo(deliveryDateStr, status, updateAtStr) {
  if (!deliveryDateStr) return { text: "Sem prazo", color: "#8c8c8c", label: "No prazo", isFinalized: false, estimatedDeadline: "" };

  const [delYear, delMonth, delDay] = deliveryDateStr.split("T")[0].split("-").map(Number);
  const deadlineDate = new Date(delYear, delMonth - 1, delDay);
  deadlineDate.setHours(0, 0, 0, 0);
  const formattedDelDate = `${String(delDay).padStart(2, "0")}/${String(delMonth).padStart(2, "0")}/${delYear}`;

  const isFinalized = status === "finalizado" || status === "assinado";
  if (isFinalized) {
    const compDateStr = updateAtStr || new Date().toISOString();
    const [compYear, compMonth, compDay] = compDateStr.split("T")[0].split("-").map(Number);
    const completionDate = new Date(compYear, compMonth - 1, compDay);
    completionDate.setHours(0, 0, 0, 0);

    const formattedCompDate = `${String(compDay).padStart(2, "0")}/${String(compMonth).padStart(2, "0")}/${compYear}`;

    if (completionDate > deadlineDate) {
      return { text: formattedCompDate, color: "#faad14", label: "Atrasado", isFinalized: true, estimatedDeadline: formattedDelDate };
    } else {
      return { text: formattedCompDate, color: "#8c8c8c", label: "Entregue", isFinalized: true, estimatedDeadline: formattedDelDate };
    }
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const diffTime = deadlineDate - today;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays < 0) {
    return { text: formattedDelDate, color: "#ff4d4f", label: "Atrasado", isFinalized: false, estimatedDeadline: formattedDelDate };
  } else if (diffDays === 0) {
    return { text: formattedDelDate, color: "#faad14", label: "Vence hoje", isFinalized: false, estimatedDeadline: formattedDelDate };
  } else {
    return { text: formattedDelDate, color: "#8c8c8c", label: "No prazo", isFinalized: false, estimatedDeadline: formattedDelDate };
  }
}

export default function SolicitacoesAdmin() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { id } = useParams();
  const [users, setUsers] = useState([]);
  const [collaborators, setCollaborators] = useState([]);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  const [page, setPage] = useState(() => {
    return Number(searchParams.get("page")) || 0;
  });
  const [ordersTotal, setOrdersTotal] = useState(0);
  const [user_id, setUser_id] = useState(() => {
    return searchParams.get("user_id") || "";
  });
  const [collaborator_id, setCollaborator_id] = useState(() => {
    return searchParams.get("collaborator_id") || "";
  });
  const [status, setStatus] = useState(() => {
    return searchParams.get("status") || "";
  });
  const [averageTime, setAverageTime] = useState(0);
  const [totalServices, setTotalServices] = useState(0);
  const [totalValue, setTotalValue] = useState(0);
  const [startDate, setStartDate] = useState(() => {
    const saved = searchParams.get("startDate");
    return saved ? new Date(saved) : addDays(new Date(), -30);
  });
  const [endDate, setEndDate] = useState(() => {
    const saved = searchParams.get("endDate");
    return saved ? new Date(saved) : new Date();
  });

  const [visibleModalItems, setVisibleModalItems] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);

  useEffect(() => {
    loadingUsersAndTecnicos();
  }, []);

  useEffect(() => {
    const params = {
      page,
      user_id,
      collaborator_id,
      status,
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
    };
    setSearchParams(params, { replace: true });

    loadingOSs(startDate, endDate, user_id, status, collaborator_id, page);
  }, [startDate, endDate, status, collaborator_id, user_id, page]);

  async function loadingUsersAndTecnicos() {
    await api
      .get(`/users?all=true`)
      .then((response) => {
        setUsers(response.data.users);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    await api
      .get(`/collaborators?all=true`)
      .then((response) => {
        setCollaborators(response.data.collaborators);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  async function loadingOSs(
    startDate,
    endDate,
    user_id,
    status,
    collaborator_id,
    page,
  ) {
    setLoading(true);
    await api
      .get(
        `/orders-admin/?startDate=${startDate}&endDate=${endDate}&page=${page}&status=${status}${
          collaborator_id && `&collaborator_id=${collaborator_id}`
        }${user_id && `&user_id=${user_id}`}`,
      )
      .then((response) => {
        setTotalValue(response.data.totalValue);
        setTotalServices(response.data.totalServices);
        setAverageTime(response.data.averageTime);
        const formattedOrders = (response.data.orders || []).map((item) => {
          let tS = item.totalServices;
          if (tS === undefined && item.items) {
            tS = item.items.reduce((acc, curr) => acc + (curr.amount || 0), 0);
          }
          return {
            ...item,
            totalServices: tS || 0,
          };
        });
        setOrders(formattedOrders);
        setOrdersTotal(response.data.ordersTotal);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoading(false);
  }

  return (
    <Container>
      <h1>Todas OSs</h1>
      {loading ? (
        <Spin style={{ marginTop: 50 }} size="large" />
      ) : (
        <>
          <Card>
            <p>Total</p>
            <CountUp separator="." duration={1} end={ordersTotal} />
          </Card>
          <div className="filters-row">
            <ViewInput style={{ width: "100%", maxWidth: 265 }}>
              <p>Selecione o Periodo</p>
              <DatePicker.RangePicker
                placeholder={["data inicial", "data final"]}
                value={[
                  startDate ? dayjs(startDate) : "",
                  endDate ? dayjs(endDate) : "",
                ]}
                locale={locale}
                format={"DD/MM/YYYY"}
                onChange={(value, dateString) => {
                  setStartDate(getDate(dateString[0]));
                  setEndDate(getDate(dateString[1]));
                  setPage(0);
                }}
                allowClear={false}
                onOk={() => {}}
              />
            </ViewInput>
            <ViewInput style={{ width: "100%", maxWidth: 200 }}>
              <p>Filtrar por Franqueado</p>
              <Select
                placeholder="selecionar franqueado"
                value={user_id}
                showSearch
                optionFilterProp="children"
                style={{ width: "100%", textAlign: "left" }}
                onChange={(value) => {
                  setUser_id(value);
                  setPage(0);
                }}
              >
                <Select.Option value={""}>Todos Franqueados</Select.Option>
                {users.map((item) => {
                  return (
                    <Select.Option value={item.id}>{item.name}</Select.Option>
                  );
                })}
              </Select>
            </ViewInput>
            <ViewInput style={{ width: "100%", maxWidth: 200 }}>
              <p>Filtrar por Técnicos</p>
              <Select
                placeholder="selecionar técnico"
                value={collaborator_id}
                showSearch
                optionFilterProp="children"
                style={{ width: "100%", textAlign: "left" }}
                onChange={(value) => {
                  setCollaborator_id(value);
                  setPage(0);
                }}
              >
                <Select.Option value={""}>Todos Técnicos</Select.Option>
                {collaborators.map((item) => {
                  return (
                    <Select.Option value={item.id}>{item.name}</Select.Option>
                  );
                })}
              </Select>
            </ViewInput>
            <ViewInput style={{ width: "100%", maxWidth: 200 }}>
              <p>Filtrar por Status</p>
              <Select
                placeholder="selecionar status"
                value={status}
                showSearch
                optionFilterProp="children"
                style={{ width: "100%", textAlign: "left" }}
                onChange={(value) => {
                  setStatus(value);
                  setPage(0);
                }}
              >
                <Select.Option value={""}>Todos Status</Select.Option>
                <Select.Option value="andamento">Em andamento</Select.Option>
                <Select.Option value="finalizado">Finalizado</Select.Option>
                <Select.Option value="alteracao">
                  Alteração Solicitada
                </Select.Option>
                <Select.Option value="pendente">
                  Documentação Pendente
                </Select.Option>
                <Select.Option value="pagamento">
                  Aguardando Pagamento
                </Select.Option>
                <Select.Option value="recusado">Recusado</Select.Option>
                <Select.Option value="cancelado">Cancelado</Select.Option>
                <Select.Option value="aberto">Aguardando Técnico</Select.Option>
              </Select>
            </ViewInput>
          </div>
          {orders.length == 0 && (
            <Message>Nenhuma Ordem de Serviço encontrada</Message>
          )}
          {!!ordersTotal && (
            <>
              <p className="resumo">
                <strong>{ordersTotal}</strong> OSs e{" "}
                <strong>{totalServices}</strong> serviços solicitados
              </p>
              {!!averageTime && (
                <p className="resumo" style={{ marginTop: 10 }}>
                  Tempo médio para conclusão das OSs:{" "}
                  {formatarDuracaoCompleta(
                    intervalToDuration({
                      start: new Date(),
                      end: addSeconds(new Date(), averageTime),
                    }),
                  )}
                </p>
              )}
              <p className="resumo" style={{ marginTop: 10 }}>
                <strong>{getValue(totalValue || 0)}</strong> total
              </p>
              <p className="resumo" style={{ marginTop: 5, marginBottom: 20 }}>
                <strong>{getValue(totalValue * 3 || 0)}</strong> média de
                faturamento
              </p>
            </>
          )}
          <div className="orders">
            {orders.map((item) => {
              return (
                <div className="order">
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {item.urgent && (
                      <Status
                        isUrgent={true}
                        style={{
                          marginRight: 10,
                          marginBottom: 7,
                          flexFlow: "nowrap",
                        }}
                      />
                    )}
                    {item.name && (
                      <p
                        style={{ width: "100%", fontSize: 11, marginBottom: 8 }}
                      >
                        {item.name}
                      </p>
                    )}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      minWidth: "120px",
                    }}
                  >
                    <p className="title" style={{ marginBottom: 5 }}>
                      #{("00000" + item.id).slice(-5)}{" "}
                    </p>
                    <Button
                      type="link"
                      style={{
                        fontSize: 12,
                        fontWeight: 600,
                        padding: "4px 12px",
                        height: "auto",
                        background: "#fff",
                        borderRadius: "50px",
                        color: "#52c41a",
                        border: "1px solid #b7eb8f",
                        marginLeft: 0,
                        alignSelf: "flex-start",
                        maxWidth: "none",
                      }}
                      onClick={() => {
                        setSelectedItems(item.items || []);
                        setVisibleModalItems(true);
                      }}
                    >
                      {item.totalServices} serviço{item.totalServices !== 1 && "s"}
                    </Button>
                  </div>
                  <div className="item" style={{ minWidth: "160px" }}>
                    <p className="title">Status</p>
                    <Status status={item.status} urgent={item.urgent} />
                  </div>
                  {item.delivery_date && (
                    <div className="item" style={{ minWidth: "150px" }}>
                      {(() => {
                        const info = getDeadlineInfo(item.delivery_date, item.status, item.update_at);
                        return (
                          <>
                            <p className="title">
                              {info.isFinalized ? "Data de entrega" : "Prazo de entrega"}
                            </p>
                            {info.isFinalized ? (
                              <Tooltip title={`Prazo estimado: ${info.estimatedDeadline}`}>
                                <p
                                  className="back"
                                  style={{
                                    fontSize: 12,
                                    color: info.color,
                                    fontWeight: "600",
                                    margin: 0,
                                    cursor: "pointer",
                                  }}
                                >
                                  {info.text}
                                </p>
                              </Tooltip>
                            ) : (
                              <p
                                className="back"
                                style={{
                                  fontSize: 12,
                                  color: info.color,
                                  fontWeight: "600",
                                  margin: 0,
                                }}
                              >
                                {info.text} ({info.label})
                              </p>
                            )}
                          </>
                        );
                      })()}
                    </div>
                  )}
                  <div className="item" style={{ minWidth: "140px" }}>
                    <p className="title">Última atualização</p>
                    <p
                      className="back"
                      style={{
                        fontSize: 12,
                        margin: 0,
                      }}
                    >
                      {format(new Date(item.update_at), "dd/MM/yyyy HH:mm")}
                    </p>
                  </div>
                  <Button
                    type="primary"
                    onClick={() => {
                      navigate("/admin/os/" + item.id);
                    }}
                    style={{ margin: 0 }}
                  >
                    Detalhes
                  </Button>

                  {!!item.averageTime && (
                    <p style={{ width: "100%", fontSize: 11, marginTop: 10 }}>
                      OS concluida em{" "}
                      {formatarDuracaoCompleta(
                        intervalToDuration({
                          start: new Date(),
                          end: addSeconds(new Date(), item.averageTime),
                        }),
                      )}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
          <Pagination
            style={{
              margin: "25px 0",
              alignSelf: "center",
            }}
            defaultCurrent={page + 1}
            pageSize={30}
            onChange={(page) => {
              setPage(page - 1);
            }}
            total={ordersTotal}
          />
        </>
      )}
      <Modal
        title="Listagem de Serviços"
        open={visibleModalItems}
        onCancel={() => setVisibleModalItems(false)}
        footer={[
          <Button key="close" onClick={() => setVisibleModalItems(false)}>
            Fechar
          </Button>,
        ]}
      >
        {selectedItems.length > 0 ? (
          <div style={{ maxHeight: "60vh", overflowY: "auto" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontWeight: "bold",
                borderBottom: "1px solid #f0f0f0",
                padding: "10px 0",
              }}
            >
              <span>Serviço</span>
              <span>Quantidade</span>
            </div>
            {selectedItems.map((item, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "10px 0",
                  borderBottom: "1px solid #f0f0f0",
                }}
              >
                <span>{item.name}</span>
                <span>{item.amount}x</span>
              </div>
            ))}
          </div>
        ) : (
          <p>Nenhum serviço encontrado para esta OS.</p>
        )}
      </Modal>
    </Container>
  );
}
